var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import Vue from "vue";
import { FilterApplyMode } from "@core/plugin/tc/component/table/types";
import { Component, Prop } from "vue-property-decorator";
import { asQueryString } from "@core/helper/url";
var BaseTableFilterMixin = /** @class */ (function (_super) {
    __extends(BaseTableFilterMixin, _super);
    function BaseTableFilterMixin() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.isLoading = false;
        _this.FilterApplyMode = FilterApplyMode;
        return _this;
    }
    Object.defineProperty(BaseTableFilterMixin.prototype, "isValueDefault", {
        get: function () {
            var _this = this;
            var queryValue = this.queryValue;
            return (this.value.length == this.defaultValue.length &&
                this.value.every(function (o) { return _this.defaultValue.indexOf(o) !== -1; }) &&
                (queryValue.length == 0 || (queryValue.length == this.defaultValue.length &&
                    queryValue.every(function (o) { return _this.defaultValue.indexOf(o) !== -1; }))));
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BaseTableFilterMixin.prototype, "queryValue", {
        get: function () {
            var value = asQueryString(this.$route.query[this.queryName]);
            if (value != null) {
                return value.split(',');
            }
            return [];
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BaseTableFilterMixin.prototype, "applyTooltip", {
        get: function () { return gettext('Apply'); },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BaseTableFilterMixin.prototype, "resetTooltip", {
        get: function () { return gettext('Reset to default'); },
        enumerable: false,
        configurable: true
    });
    BaseTableFilterMixin.prototype.data = function () {
        this.queryName = "".concat(this.prefix, "filter_").concat(this.field.name);
        var defaultValue = this.options.default != null ? this.options.default : [];
        var rawValue = asQueryString(this.$route.query[this.queryName]);
        var value = rawValue != null ? rawValue.split(',') : __spreadArray([], defaultValue, true);
        return {
            defaultValue: defaultValue,
            value: value
        };
    };
    BaseTableFilterMixin.prototype.mounted = function () {
        this.reportState();
    };
    BaseTableFilterMixin.prototype.reportState = function () {
        if (!this.isValueDefault) {
            this.$emit('active', this.field.name);
        }
        else {
            this.$emit('inactive', this.field.name);
        }
    };
    BaseTableFilterMixin.prototype.reset = function () {
        this.value = this.defaultValue;
        this.filter();
    };
    BaseTableFilterMixin.prototype.filter = function () {
        var _a;
        var _this = this;
        this.isLoading = true;
        var query = (_a = {},
            _a[this.queryName] = this.value.filter(function (o) { return o != null && o.length > 0; }).join(','),
            _a);
        this.$emit('filter', query, function () {
            _this.isLoading = false;
            _this.reportState();
        });
    };
    __decorate([
        Prop({ type: Object })
    ], BaseTableFilterMixin.prototype, "field", void 0);
    __decorate([
        Prop({ type: String })
    ], BaseTableFilterMixin.prototype, "prefix", void 0);
    __decorate([
        Prop({ type: Object })
    ], BaseTableFilterMixin.prototype, "options", void 0);
    __decorate([
        Prop({ type: Boolean, default: false })
    ], BaseTableFilterMixin.prototype, "isVisible", void 0);
    BaseTableFilterMixin = __decorate([
        Component
    ], BaseTableFilterMixin);
    return BaseTableFilterMixin;
}(Vue));
export default BaseTableFilterMixin;
